<template>

  <v-card class="position-relative">

    <v-card-text>

      <h3 class="title">Drag to select speed range</h3>

      <v-range-slider
        v-model="range"
        :min="min"
        :max="max"
        :step="5"
        hide-details
        :thumb-size="38"
        :thumb-label="showThumbs"
        class="mx-4"
        @end="handleChange"
      ></v-range-slider>

      <v-layout>

        <v-flex xs12 sm6>
          <v-text-field v-model="range[0]"
                        @change="handleChange"
                        type="number"
                        :step="5"
                        outlined
                        height="10"
                        hint="Lower end"
                        persistent-hint
                        class="ma-1"
          >
          </v-text-field>
        </v-flex>

        <v-flex xs12 sm6>
          <v-text-field v-model="range[1]"
                        @change="handleChange"
                        type="number"
                        :step="5"
                        outlined
                        hint="Upper end"
                        persistent-hint
                        class="ma-1"
          >
          </v-text-field>
        </v-flex>

      </v-layout>

    </v-card-text>

  </v-card>

</template>

<script>
// import min from 'lodash/min';
// import max from 'lodash/max';

export default {

  name: 'FilterSpeeds',

  data() {
    return {
      showThumbs: false,
      range: [],
      min: 0,
      max: 1000,
    };
  },

  mounted() {
    this.setRangeFromQueryParams();
    this.$store.commit('SET_SPEED_LOW', 0);
    this.$store.commit('SET_SPEED_HIGH', 1000);
  },

  methods: {

    setRangeFromQueryParams() {
      // const filters = this.$route.query.filters
      //   ? JSON.parse(this.$route.query.filters)
      //   : {
      //     lowSpeed: 0,
      //     highSpeed: 1000,
      //   };
      //
      // if (filters) {
      //   this.range.splice(0, 1, filters.lowSpeed);
      //   this.range.splice(1, 1, filters.highSpeed);
      // }
      this.range.splice(0, 1, this.$store.state.filters.speedLow);
      this.range.splice(1, 1, this.$store.state.filters.speedHigh);
    },

    handleChange() {
      const lowSpeed = this.range[0];
      let highSpeed = this.range[1];

      if (highSpeed > this.max) {
        highSpeed = this.max;
      }

      this.$store.commit('SET_SPEED_LOW', lowSpeed);
      this.$store.commit('SET_SPEED_HIGH', highSpeed);
    },

  },

  watch: {

    // eslint-disable-next-line
    '$route.query'() {
      this.setRangeFromQueryParams();
    },

  },

};
</script>
